// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.P2PChatInfo__content-bc6c82 {
  display: flex;
  flex-direction: column;
  margin-inline-start: 12px;
  justify-content: space-between;
  align-items: flex-start;
  overflow: hidden;
}

.P2PChatInfo__title-b85c0a {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
  overflow: hidden;
  display: flex;
  align-items: center;
  max-width: 100%;
}

.P2PChatInfo__online-status-d24d62 {
  text-align: left;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}

.P2PChatInfo__name-b82bd8 {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/ChatInfo/P2PChatInfo/P2PChatInfo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACF;;AAEA;EACE,gBAAA;EACA,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  margin-inline-start: 12px;\n  justify-content: space-between;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n}\n\n.online-status {\n  text-align: left;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n\n.name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `P2PChatInfo__content-bc6c82`,
	"title": `P2PChatInfo__title-b85c0a`,
	"online-status": `P2PChatInfo__online-status-d24d62`,
	"onlineStatus": `P2PChatInfo__online-status-d24d62`,
	"name": `P2PChatInfo__name-b82bd8`
};
module.exports = ___CSS_LOADER_EXPORT___;
